import { cartStore } from '@/cart/cart-store'
import { optimisticCacheProduct } from '@/cart/optimistic-updates/optimistic-cache-product'
import 'vite/modulepreload-polyfill'
import { datadogRum } from '@datadog/browser-rum'
import datadogConfig from '~/datadog.config'
import Experiment from '@/feature-flags/experiment'

Experiment.initGlobal(window)

// Localize cart API
type ShopifyGlobal = Window & { Shopify?: { routes?: { root?: string } } }
cartStore.rootRoute = (window as ShopifyGlobal).Shopify?.routes?.root ?? '/'
;(window as unknown as Window & { cart: unknown }).cart = {
  cartStore,
  optimisticCacheProduct
}

datadogRum.init(datadogConfig)

document.dispatchEvent(new CustomEvent('MainLoaded'))
